import dayjs from 'dayjs';

/** "Paused by {user} on {Aug 4, 2026}"; null when the backend has no record (pre-DV-2550 connections). */
export const formatPausedBy = (disabledBy: string | null, disabledAt: string | null): string | null => {
  if (!disabledBy || !disabledAt) return null;
  return `Paused by ${disabledBy} on ${dayjs(disabledAt).format('MMM D, YYYY')}`;
};
